import React from 'react'

export default ({ text }) => (<p style={{ fontSize: 52 }} >{text}</p>)





// WEBPACK FOOTER //
// ./src/components/Regular/Title.js